import { createContext } from "react";
import { Score as SureScore } from "src/types";
import { ScoreDetailBuilder } from "./ScoreDetailBuilder";
import { Drilldown } from "./useDrilldown";
import { TabConfig } from "src/components/ScoreDetail/InnerTabs/ScoreDetailTabs";
import { ScoreDetails } from "../EntityBasedScore/ScoreService";

type ScoreDetailContextInitialValues = {
    prevCampaign: string;
    scoreDetailBuilder?: ScoreDetailBuilder;
    scoreDetail: SureScore;
    drilldownState: Drilldown;
    tabConfig: TabConfig;
    scoreList: ScoreDetails;
};

export const ScoreDetailContext = createContext<ScoreDetailContextInitialValues | null>(null);
